import { render, staticRenderFns } from "./gaia-editor.vue?vue&type=template&id=40b3630e&scoped=true&"
import script from "./gaia-editor.vue?vue&type=script&lang=js&"
export * from "./gaia-editor.vue?vue&type=script&lang=js&"
import style0 from "./gaia-editor.vue?vue&type=style&index=0&id=40b3630e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b3630e",
  null
  
)

export default component.exports